export default __webpack_public_path__ + "static/media/Privacy-Policy.61149f6f.jpg";